import { useState } from 'react';
import { BountiesProvider } from '../contexts/BountiesContext';
import BountiesMain from '../features/bounties/BountiesMain';

import BountiesSideBar from '../features/bounties/BountiesSideBar';
import RequestCreated from '../features/bounties/RequestCreated';
import ThemeToggleButton from '../ui/ThemeToggleButton';

function AddBounty() {
    const [step, setStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [isBackerRequired, setIsBackerRequired] = useState(true);

    const [isFundingRequested, setIsFundingRequested] = useState(false);

    const backerHandler = (val) => {
        setIsBackerRequired(val);
    };

    const fundingRequestedHandler = (val) => {
        setIsFundingRequested(val);
    };

    return (
        <div
            className={`grid ${step === 7 ? 'grid-cols-1  ' : 'grid-cols-createBounty'
                }  overflow-hidden      pr-0   `}
        >
            <ThemeToggleButton variant="floating" />
            <BountiesProvider>
                {step === 7 ? (
                    <RequestCreated isFundingRequested={isFundingRequested} />
                ) : (
                    <>
                        <BountiesSideBar
                            completedSteps={completedSteps}
                            setCompletedSteps={setCompletedSteps}
                            step={step}
                            setStep={setStep}
                            isBackerRequired={isBackerRequired}
                        />
                        <BountiesMain
                            completedSteps={completedSteps}
                            setCompletedSteps={setCompletedSteps}
                            step={step}
                            setStep={setStep}
                            fundingRequestedHandler={fundingRequestedHandler}
                            backerHandler={backerHandler}
                        />
                    </>
                )}
            </BountiesProvider>
        </div>
    );
}

export default AddBounty;
